"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cookies_1 = require("./cookies");
const messages_1 = require("./elements/messages");
const updateConsentSettings_1 = require("./updateConsentSettings");
function initCookieControl(lang) {
    const blackList = ["_ga", "_ga_", "_gid", "_gat", "_hj", "__utma", "__utmt", "__utmb", "__utmc", "__utmz", "__utmv",
        "ki_r", "ki_s", "ki_t", "ki_u", "pi_opt_in", "visitor_id", "_gcl_au", "_uetvid"];
    let cookieMonsterInterval;
    function cookieMonster(blackList) {
        let prevCookie = "";
        function clearCookies() {
            if (document.cookie !== prevCookie) {
                prevCookie = document.cookie;
                for (const [key] of cookies_1.default.all()) {
                    const isBlackListed = blackList.findIndex(pattern => key.includes(pattern)) >= 0;
                    if (isBlackListed) {
                        cookies_1.default.clear(key);
                    }
                }
            }
        }
        window.addEventListener("beforeunload", clearCookies);
        window.addEventListener("pagehide", clearCookies);
        window.addEventListener("visibilitychange", clearCookies);
        cookieMonsterInterval = window.setInterval(clearCookies, 1000);
    }
    function asyncLoadingComplete() {
        dataLayer.push({ event: "async-loading-complete" });
    }
    const cookiesEnabled = (() => {
        const acceptCookies = cookies_1.default.get("acceptcookies");
        if (acceptCookies === "true") {
            return true;
        }
        else if (acceptCookies === "false") {
            return false;
        }
        return undefined;
    })();
    if (cookiesEnabled === true) {
        asyncLoadingComplete();
        return;
    }
    else if (cookiesEnabled === false) {
        cookieMonster(blackList);
        return;
    }
    else {
        cookieMonster(blackList);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function el(nodeName, tabindex = 1, props = {}, ...elements) {
        const result = document.createElement(nodeName);
        result.tabIndex = tabindex;
        for (const key in props) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            result[key] = props[key];
        }
        result.append(...elements);
        return result;
    }
    function div(className, ...children) {
        const div = document.createElement("div");
        div.className = className;
        div.append(...children);
        return div;
    }
    function rdiv(...elements) {
        const result = div("cookie-button-container", ...elements);
        return result;
    }
    const a = (href, title) => el("a", 2, { href }, title);
    function button(className, title, onClick, id) {
        const button = document.createElement("button");
        button.id = id;
        button.tabIndex = 1;
        button.className = className;
        button.append(title);
        button.addEventListener("click", onClick);
        return button;
    }
    const messages = {
        en: {
            cookieTitle: "Consent to website analysis",
            weUseCookies: "We use cookies and other technologies. Some of them are necessary for the website to function and are always set. Cookies for website analysis are not required and are set only with your consent. Some services for analysis process personal data in the USA. With your consent to use these services, you also consent to the processing of your data in the USA. Your consent is voluntary and can be revoked at any time. ",
            findOut: "For more information, please see our Cookie Policy.",
            accept: "Accept optional analytics cookies",
            reject: "Reject non-essential cookies",
            cookieTitleReduced: "Cookie information",
            weUseCookiesReduced: "We only use necessary cookies to be able to offer you our web services to the full extent. ",
            seePolicy: "In our Cookie Policy you can find more details about all cookies we use and for what purposes.",
            close: "Close",
            policyUrl: "/publishing/our-cookie-policy"
        },
        de: {
            cookieTitle: "Einwilligung in die Websiteanalyse",
            weUseCookies: "Wir verwenden Cookies und andere Technologien. Einige davon sind für die Funktion der Website notwendig und werden immer gesetzt. Cookies zur Website-Analyse sind nicht erforderlich und werden nur nach Ihrer Einwilligung gesetzt. Einige Services zur Analyse verarbeiten personenbezogene Daten in den USA. Mit Ihrer Einwilligung zur Nutzung dieser Services stimmen Sie auch der Verarbeitung Ihrer Daten in den USA zu. Ihre Einwilligung ist freiwillig und kann jederzeit widerrufen werden. ",
            findOut: "Weitere Informationen finden Sie in unserer Cookie-Richtlinie.",
            accept: "Optionale Analyse-Cookies akzeptieren",
            reject: "Nicht notwendige Cookies ablehnen",
            cookieTitleReduced: "Cookie-Information",
            weUseCookiesReduced: "Wir verwenden nur notwendige Cookies, um Ihnen unsere Webservices vollumfänglich anbieten zu können. ",
            seePolicy: "In unserer Cookie-Richtlinie finden Sie weitere Details zu allen Cookies, die wir einsetzen und zu welchen Zwecken.",
            close: "Schließen",
            policyUrl: "/publishing/unsere-cookie-richtlinien"
        }
    }[lang];
    const cookieBanner = div("cookie-banner cookie-hidden", div("cookie-container", div("cookie-title-container", div("cookie-title", messages.cookieTitle), messages.weUseCookies, a(messages.policyUrl, messages.findOut)), rdiv(button("cookie-button-accept", messages.accept, onAccept, "accept-cookie-banner"), button("cookie-button-reject", messages.reject, onReject, "reject-cookie-banner"))));
    const cookieBannerReduced = div("cookie-banner cookie-hidden", div("cookie-container", div("cookie-title-container", div("cookie-title", messages.cookieTitleReduced), messages.weUseCookiesReduced, a(messages.policyUrl, messages.seePolicy)), rdiv(button("cookie-button-reject", messages.close, onClose, "close-reduced-cookie-banner"))));
    function shouldShowCookieBannerReduced() {
        if (!cookies_1.default.get("acceptcookies")) {
            onReject();
            showCookieBannerReduced();
        }
    }
    function showCookieBannerReduced() {
        cookieBannerReduced.classList.remove("cookie-hidden");
        const closeButton = document.getElementById("close-reduced-cookie-banner");
        if (closeButton != null) {
            closeButton.focus();
        }
    }
    function closeCookieBanner() {
        cookieBanner.classList.add("cookie-hidden");
        setTimeout(() => cookieBanner.remove(), 300);
    }
    function onAccept() {
        cookies_1.default.set("acceptcookies", "true", 365 * 24 * 3600);
        (0, updateConsentSettings_1.updateConsentSettings)({
            "ad_storage": "granted",
            "analytics_storage": "granted",
            "ad_user_data": "granted",
            "ad_personalization": "granted"
        });
        closeCookieBanner();
        clearInterval(cookieMonsterInterval);
        asyncLoadingComplete();
    }
    function onReject() {
        cookies_1.default.set("acceptcookies", "false", 365 * 24 * 3600);
        (0, updateConsentSettings_1.updateConsentSettings)({
            "ad_storage": "denied",
            "analytics_storage": "denied",
            "ad_user_data": "denied",
            "ad_personalization": "denied"
        });
        closeCookieBanner();
        cookieMonster(blackList);
    }
    function onClose() {
        cookieBannerReduced.classList.add("cookie-hidden");
        setTimeout(() => cookieBannerReduced.remove(), 300);
    }
    // when the browser has Do not track activated, we will display the reduced banner and reject cookies
    window.addEventListener("load", () => {
        document.body.append(cookieBanner, cookieBannerReduced);
        if (navigator.doNotTrack === "1") {
            onReject();
            showCookieBannerReduced();
        }
        else {
            cookieBanner.classList.remove("cookie-hidden");
            const acceptButton = document.getElementById("accept-cookie-banner");
            if (acceptButton != null) {
                acceptButton.focus();
            }
            setTimeout(() => shouldShowCookieBannerReduced(), 30000);
        }
    });
}
if (navigator.webdriver) {
    console.debug("Selenium detected. Don't ask for cookie preferences.");
}
else {
    initCookieControl(messages_1.default.code);
}
